// extracted by mini-css-extract-plugin
export default {"headBox":"HeadersJsonUI_headBox__blxai","headEntity":"HeadersJsonUI_headEntity__0qoMv","headerKey":"HeadersJsonUI_headerKey__qRDY3","table":"HeadersJsonUI_table__WybCv"};